import React, { useEffect, useState } from "react";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import AgendaForm from "./AgendaForm";
import Lang from "../../userPreferences/staticWords";
import { customStyle, styleStart } from "../../algorithms/styleDirection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Titlebar from "../layout/titlebar";
import DateInput from "../sharedComponents/datesInputs/date";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgendaAPI,
  getAllAgendaAPI,
  getAllLinksAPI,
  getLinkAPI,
} from "../../API/store/actions/agendaAndLinks";
import { deleteAgenda, deleteLink } from "../../API/services/agendaAndLinks";
import { FormSelect, Modal } from "react-bootstrap";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Button from "../sharedComponents/buttons/button";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getTaskSearch } from "../../API/store/actions/tasks";
import Slide from "react-reveal/Slide";
import AgendaCard from "./AgendaCard";
import Paginate from "../layout/paginate";

const AgendaAndLinksManagment = () => {
  const [showAgendaModal, setShowAgendaModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [agendaPage, setAgendaPage] = useState(1);
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);
  const data = useSelector((state) => state.agenda.agenda);
  const agendas = data?.data;
  const totalAgendas = data?.count;
  const [showSearch, setShowSearch] = useState(false);
  const [searchParams, setSearchParams] = useState({
    memberId: 0,
    communityId: 0,
    startDate: null,
    endDate: null,
    attend: undefined,
    planned: undefined,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [agendaLoading, setAgendaLoading] = useState(false);
  const [linksLoading, setLinksLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [planned, setPlanned] = useState(true);

  let membersList = [];
  let communitiesList = [];
  const communityId = 0;

  const [searchDropdowns, setSearchDrobdowns] = useState({});
  useEffect(() => {
    resolver(getTaskSearch, setSearchDrobdowns, communityId, userToken);
  }, [communityId, userToken]);

  const formatDateOnly = (date) => {
    if (!date) return undefined;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const setCurrentPageandResetData = (
    setCurrentPage,
    currentPage,
    clearData,
  ) => {
    if (clearData) clearData();
    setCurrentPage(currentPage);
  };

  const fetchAgendas = async () => {
    setAgendaLoading(true);

    try {
      const payload = {
        active: true,
        memberId:
          searchParams.memberId === 0 ? undefined : searchParams.memberId,
        communityId:
          searchParams.communityId === 0 ? undefined : searchParams.communityId,
        startDate: formatDateOnly(searchParams.startDate),
        endDate: formatDateOnly(searchParams.endDate),
        planned: searchParams.planned,
        attend: searchParams.attend,
      };

      const action = await getAllAgendaAPI(payload, 10, agendaPage, userToken);

      dispatch(action);
    } finally {
      setAgendaLoading(false);
    }
  };
  useEffect(() => {
    fetchAgendas();
  }, [agendaPage, userToken, searchParams]);
  if (searchDropdowns?.data?.members) {
    membersList = searchDropdowns?.data?.members.map((item) => ({
      value: item.memberId,
      label: item.memberName,
    }));
    membersList.unshift({ value: 0, label: "الكل" });
  }
  if (searchDropdowns?.data?.communities) {
    communitiesList = searchDropdowns?.data?.communities.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    communitiesList.unshift({ value: 0, label: "الكل" });
  }
  const plannedOptions = [
    { value: undefined, label: "الكل" },
    { value: true, label: "مخطط" },
    { value: false, label: "غير مخطط" },
  ];
  const handleDelete = async () => {
    setDeleting(true);

    try {
      const payload = {
        id: deleteId,
        modifierId: user.id,
      };

      if (deleteType === "agenda") {
        await deleteAgenda(payload, userToken);
        await fetchAgendas();
      }

      setShowDeleteModal(false);
      setDeleteId(null);
      setDeleteType(null);
    } catch (err) {
      console.log(err);
    } finally {
      setDeleting(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date)) return "";

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div>
      <Titlebar title={Lang.agenda} customImage={"/assets/images/icon3.svg"} />
      <div
        style={{
          position: "relative",
          zIndex: 300,
          overflow: "visible",
        }}
      >
        <Slide left opposite collapse when={showSearch}>
          <div
            className={`d-flex flex-column col-9 col-md-12 ${styleStart(
              "p",
              4,
              "md",
            )}  justify-content-start align-items-start mt-3 `}
          >
            <div
              className="row g-3 align-items-end upperZIndex"
              style={{
                width: "700px",
                maxWidth: "100%",
                // border: "1px solid #e9ecef",
              }}
            >
              {/* <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">الجهة المشاركة</label>
                <FormSelect
                  value={searchParams.memberId}
                  onChange={(e) =>
                    setSearchParams((prev) => ({
                      ...prev,
                      memberId: Number(e.target.value),
                    }))
                  }
                >
                  {membersList.map((member) => (
                    <option key={member.value} value={member.value}>
                      {member.label}
                    </option>
                  ))}
                </FormSelect>
              </div> */}
              <div className="col-md-12 col-lg-4 mx-4 mx-md-0">
                <label className="form-label fw-bold"> نوع الفعالية </label>
                <FormSelect
                  value={
                    searchParams.planned === undefined
                      ? ""
                      : searchParams.planned.toString()
                  }
                  onChange={(e) => {
                    const value = e.target.value;

                    setSearchParams((prev) => ({
                      ...prev,
                      planned: value === "" ? undefined : value === "true",
                    }));
                  }}
                >
                  <option value="">الكل</option>
                  <option value="true">مخطط</option>
                  <option value="false">غير مخطط</option>
                </FormSelect>
              </div>
              <div className="col-md-12 col-lg-4 mx-4 mx-md-0">
                <label className="form-label fw-bold"> نوع الحضور </label>
                <FormSelect
                  value={
                    searchParams.attend === undefined
                      ? ""
                      : searchParams.attend.toString()
                  }
                  onChange={(e) => {
                    const value = e.target.value;

                    setSearchParams((prev) => ({
                      ...prev,
                      attend: value === "" ? undefined : value === "true",
                    }));
                  }}
                >
                  <option value="">الكل</option>
                  <option value="true">فعلي</option>
                  <option value="false"> افتراضى</option>
                </FormSelect>
              </div>

              <div className="col-md-12 col-lg-4 mx-4 mx-md-0">
                <label className="form-label fw-bold">المحور</label>

                <FormSelect
                  value={searchParams.communityId}
                  onChange={(e) =>
                    setSearchParams((prev) => ({
                      ...prev,
                      communityId: Number(e.target.value),
                    }))
                  }
                >
                  {communitiesList.map((community) => (
                    <option key={community.value} value={community.value}>
                      {community.label}
                    </option>
                  ))}
                </FormSelect>
              </div>
              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">من </label>

                <DateInput
                  value={searchParams.startDate}
                  onChange={(value) =>
                    setSearchParams((prev) => ({
                      ...prev,
                      startDate: value,
                    }))
                  }
                  isClearable
                  inputStyle={"upperZIndex"}
                  placeholder={Lang.form}
                  iconPrefix="far"
                  iconName="calendar"
                />
              </div>

              <div className="col-md-12 col-lg-6 mx-4 mx-md-0">
                <label className="form-label fw-bold">إلى </label>

                <DateInput
                  value={searchParams.endDate}
                  onChange={(value) =>
                    setSearchParams((prev) => ({
                      ...prev,
                      endDate: value,
                    }))
                  }
                  isClearable
                  inputStyle={"upperZIndex"}
                  placeholder={Lang.form}
                  iconPrefix="far"
                  iconName="calendar"
                />
              </div>
            </div>
          </div>
        </Slide>
      </div>
      <div className="container-fluid px-2 ">
        <div className="row g-4 align-items-start ">
          <div className="col-10 col-lg-9 mb-4">
            <CardWithTitleAndIcon
              onClick={() => {
                setIsEdit(false);
                setShowAgendaModal(true);
              }}
              containerStyle="d-flex justify-content-center align-items-center d-lg-none col-10 align-self-center mb-5"
              customImage={"/assets/images/add-calender.png"}
              cardTitle={Lang.createNewCalender}
              height={90}
              width={230}
              imgHeight={50}
              imgWidth={60}
              containerImgHeight={50}
              containerImgWidth={60}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
              borderColor={"rgba(68, 68, 68, 0.25)"}
            />
            <div className="card-body m-0 ">
              {agendaLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-success" />
                </div>
              ) : agendas?.length ? (
                agendas.map((item) => (
                  <AgendaCard
                    key={item.id}
                    agenda={item}
                    onEdit={async (agenda) => {
                      const action = await getAgendaAPI(agenda.id, userToken);

                      dispatch(action);
                      setIsEdit(true);
                      setShowAgendaModal(true);
                    }}
                    onDelete={(agenda) => {
                      setDeleteId(agenda.id);
                      setDeleteType("agenda");
                      setShowDeleteModal(true);
                    }}
                  />
                ))
              ) : (
                <div className="text-center py-5">لا توجد بيانات</div>
              )}
              {totalAgendas > 0 && !agendaLoading ? (
                <div className="my-3 d-flex justify-content-center col-lg-8">
                  <Paginate
                    currentPage={agendaPage}
                    pageCount={Math.ceil(totalAgendas / 10)}
                    setCurrentPage={setAgendaPage}
                    setCurrentPageandResetData={setCurrentPageandResetData}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-12 col-lg-auto d-flex justify-content-start my-4">
            <CardWithTitleAndIcon
              onClick={() => {
                setIsEdit(false);
                setShowAgendaModal(true);
              }}
              containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
                "createTaskButton",
              )}`}
              customImage={"/assets/images/add-calender.png"}
              cardTitle={Lang.createNewCalender}
              height={150}
              width={180}
              imgHeight={70}
              imgWidth={80}
              containerImgHeight={70}
              containerImgWidth={80}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
              borderColor={"rgba(68, 68, 68, 0.25)"}
            />
          </div>
        </div>
        <div
          className={`${customStyle("filterIcon")}`}
          style={{
            zIndex: 300,
            top: "150px",
            width: "80px",
            height: "80px",
          }}
          title={Lang.search}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              marginTop: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>
      </div>
      <AgendaForm
        show={showAgendaModal}
        setShow={setShowAgendaModal}
        isEdit={isEdit}
        onSuccess={fetchAgendas}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        centered
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="fw-bold text-danger"
          >
            <div className="d-flex align-items-center mx-md-3 mx-1">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <img
                  src="/assets/images/deleteicon.png"
                  width={20}
                  height={20}
                  alt=""
                />
              </div>
              <div className="text-dark d-flex align-content-center">
                <p
                  className="my-0 "
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "rgb(12, 87, 76)",
                  }}
                >
                  {" "}
                  {Lang.deleteTitle}
                </p>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <div className=" d-flex flex-column  align-items-center justify-content-center">
          <img src="/assets/images/fi-br-info.png" />
          <div className="my-2">{Lang.deleteMessage}</div>
          <div className="d-flex justify-content-center flex-wrap w-100 my-3">
            <Button
              containerStyle={"col-3 mx-2"}
              content={getDir(getCurrentLangFromRedux()) == "rtl" ? "لا" : "No"}
              onClick={() => setShowDeleteModal(false)}
            />
            <Button
              containerStyle={"col-3 mx-2 "}
              content={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "نعم" : "Yes"
              }
              buttonStyleType={"solid"}
              disable={deleting}
              onClick={handleDelete}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AgendaAndLinksManagment;
